export const CALCULATION_REPORT_CODE = "calc";
export const WORKERS_REPORT_CODE = "worker";
export const PERSONAL_REPORT_CODE = "personal";
export const REPORT_CODES = [CALCULATION_REPORT_CODE, WORKERS_REPORT_CODE, PERSONAL_REPORT_CODE];

export const REPORT_TITLES = {
    [CALCULATION_REPORT_CODE]: "OLAP-отчеты по расчетам",
    [WORKERS_REPORT_CODE]: "OLAP-отчеты по сотрудникам",
    [PERSONAL_REPORT_CODE]: "OLAP-отчеты по проводкам ЛС",
};
export const NEW_REPORT_TITLES = {
    [CALCULATION_REPORT_CODE]: "Новый отчет по расчетам",
    [WORKERS_REPORT_CODE]: "Новый отчет по сотрудникам",
    [PERSONAL_REPORT_CODE]: "OLAP-отчеты по проводкам ЛС",
};
